/**
 * @generated SignedSource<<34978acd15c0600135c2eac6f806f703>>
 * @relayHash 162b6024a874e1f413829bafa1240725
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 162b6024a874e1f413829bafa1240725

import { ConcreteRequest } from 'relay-runtime';
export type AiResult = "APPOINTMENT_IS_MISSING_CHAT_THREAD_ID" | "BREACHED_CONTENT_FILTER" | "FUNCTION_CALL" | "INVALID_QUESTIONNAIRE_DATA" | "JSON_ERROR" | "MAXIMUM_NUMBER_OF_TOKENS_EXCEEDED" | "MISSING_APPOINTMENT_DATA" | "MISSING_CALL_TRANSCRIPT" | "MISSING_CHAT_TRANSCRIPT" | "MISSING_CLINIBEE_GUIDELINES" | "MISSING_PROMPT_FOR_REQUESTED_LANGUAGE" | "MISSING_QUESTIONNAIRE_DATA" | "MISSING_USER_INPUT" | "MISSING_USER_PROMPT" | "NOT_FOUND_OPEN_AI_PROMPT" | "PROCESS_TIMEOUT" | "SUCCESS" | "TOOL_CALLS" | "UNKNOWN_ERROR" | "UNRESOLVED_PLACEHOLDER" | "UNSUPPORTED_PLACEHOLDER";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type AiRequestMetadataInput = {
  age: number;
  aiFeatureId: string;
  appointmentId: string;
  gender: Gender;
  progressNoteId?: string | null;
  progressNotes?: ReadonlyArray<ProgressNoteAnamnesisInput> | null;
  specialtyOfPointOfCareForCurrentProgressNote?: string | null;
  targetAgentLanguage?: Language | null;
  userInput?: string | null;
};
export type ProgressNoteAnamnesisInput = {
  anamnesis: string;
  updatedAt: string;
};
export type summarizeConsultationReportQuery$variables = {
  aiRequestMetadata: AiRequestMetadataInput;
};
export type summarizeConsultationReportQuery$data = {
  readonly summarizeConsultationReport: {
    readonly aiAnonymizationRequestDurationMs: number;
    readonly aiRequestDurationMs: number;
    readonly anamnesisSummary: string;
    readonly fileHash: string;
    readonly recommendedTreatment: string;
    readonly result: AiResult;
  };
};
export type summarizeConsultationReportQuery = {
  response: summarizeConsultationReportQuery$data;
  variables: summarizeConsultationReportQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "aiRequestMetadata"
  }
],
v1 = [
  {
    "alias": "summarizeConsultationReport",
    "args": [
      {
        "kind": "Variable",
        "name": "aiRequestMetadata",
        "variableName": "aiRequestMetadata"
      }
    ],
    "concreteType": "ConsultationReportResult",
    "kind": "LinkedField",
    "name": "ch_summarizeConsultationReport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "anamnesisSummary",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "recommendedTreatment",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "fileHash",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiRequestDurationMs",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "aiAnonymizationRequestDurationMs",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "summarizeConsultationReportQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "summarizeConsultationReportQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "162b6024a874e1f413829bafa1240725",
    "metadata": {},
    "name": "summarizeConsultationReportQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "4c38cae0e02a2825e7fb6464d8e113ad";

export default node;
